/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import algoliasearch from "algoliasearch";
import { useAuthState } from "react-firebase-hooks/auth";
import { Outlet, NavLink } from "react-router-dom";
import { Layout, Menu, theme, Input, Divider, Row } from "antd";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  QuerySnapshot,
  where,
} from "@firebase/firestore";
import { auth, db } from "../firebase";
import UserProfile from "./UserProfile";
import AddFunctionality from "./AddFunctionality";
import HelpAndTraining from "./HelpAndTraining";
import "./MainLayout.css";
import { useDispatch } from "react-redux";
import { setUserInfo } from "../store/usersSlice";
import Logo from "../assets/images/logo.png";
import SearchBox from "./SearchBox";

const { Header, Content, Sider } = Layout;

// const APP_ID = process.env.ALGOLIA_APP_ID;
// const SEARCH_KEY = process.env.ALGOLIA_SEARCH_KEY;

const searchClient = algoliasearch(
  "XKP4MMUZB9",
  "37d87c3b710ca743a50ad4f636f0fd0f"
);
const searchIndex = searchClient.initIndex("dev_SAYEAGLE");

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const sidebBarNav = [
  getItem(
    <NavLink to="/">DASHBOARD</NavLink>,
    "dashboardKey",
    <i className="fas fa-fw fa-tachometer-alt"></i>
  ),
  getItem(
    <NavLink to="/CalendarPage">CALENDAR</NavLink>,
    "CalendarKey",
    <i className="fas fa-fw fa-calendar"></i>
  ),
  getItem("LEASING", "LeasingSubKey", <i className="fas fa-fw fa-key"></i>, [
    getItem(
      <NavLink to="/leasing/vacancies">Vacancies</NavLink>,
      "VacanciesKey"
    ),
    getItem(
      <NavLink to="/leasing/guest-cards">Guest Cards</NavLink>,
      "GuestCardsKey"
    ),
    getItem(
      <NavLink to="/leasing/rental-applications">Rental Applications</NavLink>,
      "RentalAppKey"
    ),
    getItem(<NavLink to="/leasing/leases">Leases</NavLink>, "LeasesKey"),
    getItem(<NavLink to="/leasing/renewals">Renewals</NavLink>, "RenewalsKey"),
  ]),
  getItem(
    <NavLink to="/properties">PROPERTIES</NavLink>,
    "PropertiesKey",
    <i className="fas fa-fw fa-home"></i>
  ),
  getItem("PEOPLE", "PeopleSubKey", <i className="fas fa-fw fa-users"></i>, [
    getItem(<NavLink to="/people/tenants">Tenants</NavLink>, "TenantsKey"),
    getItem(<NavLink to="/people/owners">Owners</NavLink>, "OwnersKey"),
    getItem(<NavLink to="/people/vendors">Vendors</NavLink>, "VendorsKey"),
  ]),
  getItem(
    "ACCOUNTING",
    "AccountingSubKey",
    <i className="fas fa-dollar-sign fa-2x"></i>,
    [
      getItem(
        <NavLink to="/accounting/receivables_payments">Receivables</NavLink>,
        "ReceivablesKey"
      ),
      getItem(
        <NavLink to="/accounting/payables_bills">Payables</NavLink>,
        "PayablesKey"
      ),
      getItem(
        <NavLink to="/accounting/bank_accounts">Bank Accounts</NavLink>,
        "BankAccountKey"
      ),
      getItem(
        <NavLink to="/accounting/bank_transfers_incomplete">
          Bank Transfers
        </NavLink>,
        "BankTransKey"
      ),
      getItem(
        <NavLink to="/accounting/gl-accounts">GL Accounts</NavLink>,
        "GlAccountsLKey"
      ),
    ]
  ),
  getItem(
    "MAINTENANCE",
    "MaintenanceSubkey",
    <i className="fas fa-fw fa-cogs"></i>,
    [
      getItem(
        <NavLink to="/maintenance/work-orders">Work Orders</NavLink>,
        "WorkOrderKey"
      ),
      getItem(
        <NavLink to="/maintenance/recurring-work-orders">
          Recurring Work Orders
        </NavLink>,
        "RecurringWorkKey"
      ),
      getItem(
        <NavLink to="/maintenance/inspections">Inspections</NavLink>,
        "InspectionsKey"
      ),
      getItem(
        <NavLink to="/maintenance/unit-turns">Unit Turns</NavLink>,
        "UnitTurnsKey"
      ),
    ]
  ),
  getItem(
    "REPORTING",
    "ReportingSubKey",
    <i className="fas fa-fw fa-list-alt"></i>,
    [
      getItem(<NavLink to="/reporting/reports">Reports</NavLink>, "ReportsKey"),
      getItem(
        <NavLink to="/reporting/scheduled-reports">Scheduled Reports</NavLink>,
        "ScheduledReportsKey"
      ),
      getItem(
        <NavLink to="/reporting/metrics_pricing">Metrics</NavLink>,
        "MetricsKey"
      ),
      getItem(<NavLink to="/reporting/surveys">Surveys</NavLink>, "SurveysKey"),
    ]
  ),
  getItem(
    "COMMUNICATION",
    "CommunicationSubKey",
    <i className="fas fa-comments fa-2x"></i>,
    [
      getItem(
        <NavLink to="/communication/letters_templates">Letters</NavLink>,
        "LettersKey"
      ),
      getItem(
        <NavLink to="/communication/resident-forms">Resident Forms</NavLink>,
        "ResidentFormKey"
      ),
      getItem(
        <NavLink to="/communication/messages">Messages</NavLink>,
        "MessagesKey"
      ),
      getItem(<NavLink to="/communication/email">Email</NavLink>, "EmailKey"),
      getItem(<NavLink to="/communication/chat">Chat</NavLink>, "ChatKey"),
    ]
  ),
  getItem(
    "TASKS",
    "TASKSSubkey",
    <i className="fas fa-solid fa-clipboard-check"></i>,
    [
      getItem(<NavLink to="/tasks/library">Library</NavLink>, "LibraryKey"),
      getItem(<NavLink to="/tasks/reports">Reports</NavLink>, "Reportskey"),
      getItem(<NavLink to="/tasks/inbox">Inbox</NavLink>, "InboxKey"),
    ]
  ),
  // getItem(
  //   <NavLink to="/whats-new">What's New</NavLink>,
  //   "WhatNewKey",
  //   <i className="fas fa-fw fa-archive"></i>
  // ),
];

const { Search } = Input;

const rootSubmenuKeys = [
  "LeasingSubKey",
  "PeopleSubKey",
  "AccountingSubKey",
  "MaintenanceSubkey",
  "ReportingSubKey",
  "CommunicationSubKey",
  "dashboardKey",
  "CalendarKey",
  "PropertiesKey",
  "WhatNewKey",
  "TASKSSubkey",
];
const MainLayout = () => {
  const [current, setCurrent] = useState();
  const [user, loading] = useAuthState(auth);
  const [name, setName] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [isDropdownVisible, setDropdownVisible] = useState(false);

  console.log("searchResult", searchResult);
  const dispatch = useDispatch();
  const fetchName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            const firstName = res.firstName;
            const lastName = res.lastName;
            const userData = {
              companyName: res.companyName,
              email: res.email,
              firstName: res.firstName,
              lastName: res.lastName,
              role: res.role,
              uid: res.uid,
            };
            // console.log("data999999", userData)
            setName(`${firstName} ${lastName}`);
            dispatch(setUserInfo(userData));
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
      // alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    fetchName();
    // console.log("test");
  }, [user, loading]);

  const onClick = (e) => {
    setCurrent(e.key);
  };

  const [openKeys, setOpenKeys] = useState([]);
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const onSearch = async (value) => {
    try {
      const result = await searchIndex.search(value);
      setSearchResult(result.hits);
      console.log("Result", result);
    } catch (err) {
      console.log("err", err);
      setSearchResult([]);
    }
  };

  const handleSearchText = async (e) => {
    const inputValue = e.target.value;
    setSearchText(inputValue);

    try {
      if (inputValue.trim() === "") {
        // If the input is empty, clear the results and hide the dropdown
        setSearchResult([]);
        setDropdownVisible(false);
      } else {
        const result = await searchIndex.search(inputValue);
        setSearchResult(result.hits);
        setDropdownVisible(result.hits.length > 0);
      }
    } catch (err) {
      console.log("err", err);
      setSearchResult([]);
      setDropdownVisible(false);
    }
  };

  return (
    <div className="MainLayout">
      <Layout>
        <Header
          className="header"
          style={{
            position: "fixed",
            width: "100%",
            top: 0,
            zIndex: 1,
            display: "flex",
            background: "#006eb7",
            alignItems: "center",
          }}
        >
          <h1 className="sayEagleHeaderLogo">
            {/* <i className="fas fa-laugh-wink"></i>SayEagle */}
            <img
              src={Logo}
              alt="SayEalge Logo"
              style={{ height: "80px", width: "100px" }}
            />
          </h1>
          <div className="searchBox">
            <Input
              placeholder="search "
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearch(searchText);
                }
              }}
              value={searchText}
              onChange={handleSearchText}
              style={{
                maxWidth: "600px",
                marginLeft: "64px",
              }}
            />
            {searchResult.length > 0 ? (
              <div className="search-dropdown">
                {isDropdownVisible && (
                  <SearchBox
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    setDropdownVisible={setDropdownVisible}
                    searchText={searchText}
                    setSearchText={setSearchText}
                  />
                )}
              </div>
            ) : null}
          </div>

          <div className="topHeadMenu">
            <AddFunctionality />
            <HelpAndTraining />
            <UserProfile userName={name} />
          </div>
        </Header>

        <Layout>
          <Sider
            width={220}
            style={{
              background: "rgb(14, 37, 52)",
              overflow: "auto",
              position: "fixed",
              left: 0,
              top: 64,
              bottom: 0,
            }}
          >
            <div
              style={{
                height: "100%", // Set a fixed height for the sidebar
                overflowY: "auto", // Enable vertical scrolling
              }}
            >
              <Menu
                mode="inline"
                theme="dark"
                style={{
                  height: "100%",
                  borderRight: 0,
                  background: "#0e2534",
                }}
                items={sidebBarNav}
                onClick={onClick}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
              />
            </div>
          </Sider>
          <Layout
            className="site-layout"
            style={{
              marginLeft: 220,
              marginRight: 200,
            }}
          >
            <Content
              style={{
                margin: "64px 16px 0",
                marginLeft: "auto",
                marginRight: "auto",
                minWidth: "100%",
                overflow: "initial",
                // position: "fixed"
              }}
            >
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </div>
  );
};
export default MainLayout;
